import { useEffect } from 'react';

/**
 * Custom hook to set the page title dynamically
 * @param {string} title - The page title (without "Dark Planner | ")
 */
export const usePageTitle = (title) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = `Dark Planner | ${title}`;
    
    // Cleanup: restore previous title when component unmounts
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};
